<template>
  <div class="program-grup">
    <ProgramCatalog :formValue="this.formValue" :categoryList="categoryList" :searchData="searchData"
        :rules="rules"
        ref="programForm"
        :sndCategory="sndCategory"
        :keywords_tags="keywords_tags"
        :sndOptions="sndOptions"
        @searchHandle="searchHandle"
        @sndChange="sndChange"
        @keywordsChange="keywordsChange"
        @completeHandle="completeHandle"
        @boundChange="boundChange"
        @cancelCopyRight="cancelBound"
        @form-change="formchange">
    </ProgramCatalog>
  </div>
</template>
<script>
import { fetchDictionarys, fetchCatalogItems, fetchCommonCategoryInuse, fetchUnBindCopyrights } from '@/resource/api/index'
import { programSets, addProgramSets, editProgramSets } from '@/resource/api/program-group-management'
import { getCheckArr } from '@/utils'
import ProgramCatalog from '@/components/programCatalog.vue'
import { Pinyin } from '@/utils/ChinesePY.js'

export default {
  name: 'ProgramGroup',
  components: {
    ProgramCatalog
  },
  data () {
    return {
      programSetId: '', // vod 编辑节目集id
      formValue: {
        name: '',
        nameInitials: '',
        dsc: '',
        keywords: '',
        poster: '',
        posterH: '',
        sndCategory: '',
        updateBy: ''
      }, // 表单value
      category: '', // 分类
      falg: true,
      categoryList: [], // 一级分类option
      keywords_tags: [], // 关键字
      catalogData: null, // 动态表单
      sndCategory: [], // 二级分类
      sndOptions: [],
      extraData: [],
      programId: null,
      vrTypeIndex: null,
      isVRFlag: true,
      initData: false,
      rules: {
        name: [
          { required: true, message: '请输入节目集名称', trigger: 'blur' },
          { pattern: /^[\s\S]{1,40}$/, message: '不大于40字符' }
        ],
        nameInitials: [
          { required: true, message: '请输入标题首字母', trigger: 'blur' }
        ],
        dsc: [
          { required: true, message: '请输入简介', trigger: 'blur' },
          { pattern: /^[\s\S]{1,80}$/, message: '不大于80字符', trigger: 'change' }
        ],
        keywords: [
          { required: true, message: '请输入标签', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ],
        sndCategory: [
          { required: true, message: '请选择二级分类', trigger: 'change' }
        ],
        poster: [
          { required: true, message: '请上传竖海报', trigger: 'change' }
        ],
        posterH: [
          { required: true, message: '请上传横海报', trigger: 'change' }
        ]
        // copyright: [
        //   { required: false, message: '请选择版权方', trigger: 'chang' }
        // ]
      }
    }
  },
  created () {
    this.pageInit()
  },
  watch: {
    sndCategory (val) {
      if (this.initData) {
        this.sndOptions = []
        this.formValue.keywords = ''
      }
    },
    'formValue.isVR' () {
      if (this.formValue.isVR == 0) { // vr视频选不是，播放模式、vr类型隐藏
        this.formValue.vrType = ''
        if (this.searchData[this.vrTypeIndex]) {
          this.searchData[this.vrTypeIndex].hide = true
        }
      } else {
        if (this.searchData[this.vrTypeIndex]) {
          this.searchData[this.vrTypeIndex].hide = false
        }
      }
    }
  },
  methods: {
    formchange (params) {
      if (params.event == 'blur') {
        if (params.item.isInitial == 1) {
          this.initialsChange(params.item.prop, params.item.prop + 'Initials')
        }
      } else if (params.item.prop == 'name') {
        this.initialsChange(params.item.prop, params.item.prop + 'Initials')
      }
    },
    pageInit () {
      const routerParams = this.$route.query
      this.keywords_tags = []
      this.fetchDsataDictionarys()
      if (routerParams.programSetId) {
        this.programSetId = routerParams.programSetId
        this.fetchProgramGroup()
      } else {
        this.getFormData()
      }
      this.initData = false
    },
    // 获取需要编辑节目集的详情
    fetchProgramGroup () {
      const data = {
        id: this.programSetId
      }
      programSets(data).then((res) => {
        if (res.code == 1) {
          const dataObj = res.results[0]
          this.getFormData(dataObj)
        }
      })
    },
    // 获取 FORM 表单
    getFormData (dataObj) {
      if (dataObj) {
        for (var key in dataObj) { // 数据初始化
          this.formValue[key] = dataObj[key]
          const value = this.formValue[key] == null ? '' : this.formValue[key]
          this.formValue = Object.assign({}, this.formValue, { key: value })
        }
        this.formValue.keywords = dataObj.labels
        this.formValue.programSetId = this.programSetId
      }
      if (this.formValue.category) {
        this.categoryChange(this.formValue.category)
      } else {
        this.formValue.category = ''
        this.categoryChange(this.formValue.category)
      }
      if (this.formValue) {
        var sndCategory = this.formValue.sndCategory
        if (sndCategory != undefined && sndCategory != '') {
          this.sndOptions = sndCategory.split(' ')
          // this.keywordsChange(this.sndOptions)
        }
        this.formValue.year = this.formValue.year ? this.formValue.year + '' : this.$moment().format('YYYY')
      }
      if (this.formValue.isVR == 1) {
        this.isVRFlag = false
      }
      this.formValue.platform = this.$store.state.router.cpcode
      this.formValue.score = this.formValue.score ? this.formValue.score : 0
      this.formValue.playMode = this.formValue.playMode ? this.formValue.playMode : ''
      const nameInitials = Pinyin.GetJP(this.formValue.name)
      this.formValue.nameInitials = this.formValue.nameInitials ? this.formValue.nameInitials : nameInitials

      var keywords = this.formValue.labels
      if (keywords != undefined && keywords != '') {
        this.keywords_tags = keywords.split(' ')
      }
      if (this.formValue.poster) {
        this.$nextTick(() => {
          this.$refs.programForm.posterShow()
        })
      }
      if (this.formValue.posterH) {
        this.$nextTick(() => {
          this.$refs.programForm.posterHShow()
        })
      }
      if (this.programSetId.length < 1) {
        this.formValue.contentProvider = this.$store.state.router.companyName
      }
    },
    // 一级分类option
    fetchDsataDictionarys () {
      const data = {
        limit: 30,
        dataKey: 'category',
        dataFlag: 0
      }
      if (process.env.VUE_APP_NODE_ENV == 'VOD') {
        fetchCommonCategoryInuse({ createBy: this.$store.state.router.createBySuffix }).then((res) => {
          if (res.code == '1') {
            res.result.forEach((item) => {
              this.categoryList.push({ value: item, label: item })
            })
          }
        })
      } else {
        fetchDictionarys(data).then((res) => {
          if (res.code == '1') {
            res.results.forEach((item) => {
              this.categoryList.push({ value: item.dataValue, label: item.dataValue })
            })
          }
        })
      }
    },
    // 根据分类展示动态表单
    fetchCatalogItems (category) {
      const fixedAttr = ['name', 'nameInitials', 'category', 'score', 'dsc', 'keywords', 'poster', 'posterH', 'keywords', 'labels', 'copyright', 'copyrightCode', 'crBeginDate', 'crEndDate', 'isCoverSonProCP']
      const data = {
        category: category,
        type: 'set',
        platform: process.env.VUE_APP_NODE_ENV
      }
      fetchCatalogItems(data).then((res) => {
        if (res.code == '1') {
          this.catalogData = []
          if (res.result.length > 0) {
            res.result[0].sndCategory.forEach(item => {
              if (fixedAttr.indexOf(item.itemEnName) == -1) {
                this.catalogData.push(item)
              }
            })
            const initialArr = []
            this.catalogData.forEach((item) => {
              for (const i in item) {
                if (i == 'itemEnName') {
                  var valEnName = item[i]
                  item.value = this.formValue[valEnName]
                  // 提取首字母数组
                  if (valEnName.indexOf('Initials') != -1) {
                    item.replaceVal = item.itemEnName.replace('Initials', '')
                  }
                  if (item.replaceVal) {
                    initialArr.push(item.replaceVal)
                  }
                } else if (i == 'itemCheck') {
                  const itemVal = item[i]
                  const itemCheck = getCheckArr(itemVal)
                  if (itemCheck instanceof Array) {
                    item.itemCheck = itemCheck
                    if (item.itemEnName == 'sndCategory') {
                      this.sndCategory = item.itemCheck
                    }
                    itemCheck.forEach(checkItem => {
                      const key = Number(checkItem.key)
                      checkItem.label = checkItem.value
                      checkItem.value = checkItem.key ? isNaN(key) ? checkItem.value : key : checkItem.value
                    })
                    if (item.itemType == 'radio') {
                      itemCheck.forEach(checkItem => {
                        checkItem.value = checkItem.label
                        checkItem.label = Number(checkItem.key)
                      })
                    }
                  } else {
                    item.itemCheck = itemCheck.message
                    item.customCheck = itemCheck.message
                  }
                } else if (i == 'itermDefault') { // 用于新增弹窗的字段默认值
                  const itemDefault = item[i]
                  const regPos = /^\d+(\.\d+)?$/
                  const isStr = regPos.test(itemDefault)
                  const valueKey = item.itemEnName
                  const formval = this.formValue[valueKey]
                  if (this.formValue[valueKey] == 0 || this.formValue[valueKey]) {
                    this.formValue[valueKey] = formval
                  } else {
                    if (isStr) {
                      this.formValue[valueKey] = Number(itemDefault)
                    } else {
                      this.formValue[valueKey] = itemDefault
                    }
                  }
                }
              }
            })
            // 获取二级分类下标在非固定数组中删除改组
            this.catalogData.forEach((item, index) => {
              if (item.itemType == 'hidden') {
                this.catalogData.splice(index, 1)
              }
              if (item.itemEnName == 'sndCategory') {
                this.catalogData.splice(index, 1)
              } else if (initialArr.indexOf(item.itemEnName) !== -1) {
                item.isInitial = 1 // 1: 需要提取首字母 0: 不需要提取首字母
              }
            })
            this.extraData = this.catalogData.map((item, index) => {
              if (item.itemEnName == 'vrType') {
                this.vrTypeIndex = index + 8
              }
              if (item.itemType == 'radio') {
                item.itemNeed = '1'
              }
              return {
                prop: item.itemEnName,
                rules: { required: item.itemNeed == 0, pattern: new RegExp(item.customCheck), trigger: ['blur', 'change'], message: item.itemCheckMsg ? `您的输入有误，${item.itemCheckMsg}` : '您的输入有误' },
                type: item.itemType == 'text' ? 'input' : (item.itemType == 'datePicker' ? 'time' : (item.itemType == 'number' ? 'inputNumber' : item.itemType)),
                timeType: item.itemEnName == 'year' ? 'year' : 'date',
                format: item.itemEnName == 'year' ? 'yyyy' : (item.itemEnName == 'premiereTime' || item.itemEnName == 'deployDate' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'),
                valueFormat: item.itemEnName == 'year' ? 'yyyy' : (item.itemEnName == 'premiereTime' || item.itemEnName == 'deployDate' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'),
                label: item.itemName + '：',
                placeholder: `请输入${item.itemName}`,
                clearable: false,
                labelWidth: '110px',
                radios: item.itemType == 'radio' && item.itemCheck,
                options: (item.itemType == 'select' || item.itemType == 'multiSelect') && item.itemCheck,
                isInitial: item.isInitial || 0,
                hide: item.itemEnName == 'vrType' ? this.isVRFlag : (item.itemAttr == 'hidden' ? true : ''),
                readonly: item.itemAttr == 'readonly',
                disabled: item.itemAttr == 'disabled'
              }
            })
            const obj = {}
            if (!this.programSetId) {
              this.extraData.map(item => {
                obj[item.prop] = ''
              })
            }
            this.formValue = Object.assign(obj, this.formValue)
          }
        }
      }).catch(err => {
        this.$message({
          message: err.msg,
          type: 'error'
        })
      })
    },
    // 分类Change
    categoryChange (val) {
      // 判断修改分类去掉 二级分类、标签
      this.fetchCatalogItems(val)
      if (!this.falg) {
        this.sndOptions = []
        this.formValue.keywords = ''
        this.keywords_tags = []
      } else {
        this.falg = false
      }
    },
    // 二级分类 CHANGE
    sndChange (val) {
      this.sndOptions = val
      this.formValue.sndCategory = this.sndOptions.join(' ')
    },
    // 关键字 Change 获取二级分类
    keywordsChange (val) {
      const keywordsTags = this.keywords_tags
      const tagsStr = this.arrToStr(keywordsTags)
      if (val.length > 1) {
        for (const i in val) {
          if (tagsStr.indexOf(val[i]) == -1) {
            keywordsTags.push(val[i])
          }
        }
      }
      this.formValue.keywords = keywordsTags.join(' ')
    },
    arrToStr (arr) {
      return arr.toString().replace(/,/g, ' ')
    },
    // 首字母change
    initialsChange (prop, initials) {
      var name = this.formValue[prop]
      var py = Pinyin.GetJP(name)
      this.formValue[initials] = py
    },
    // 绑定Change
    boundChange (data) {
      this.formValue.copyright = data.copyrightName
      this.formValue.copyrightCode = data.copyrightCode
      this.formValue.crBeginDate = data.startTime
      this.formValue.crEndDate = data.endTime
      this.formValue.filmId = data.filmId
      this.$message({
        type: 'info',
        message: '请点击确定提交，版权才会变更生效'
      })
    },
    cancelBound () {
      // 新增编目时无需调用接口内容清空即可 编辑调用取消绑定接口
      if (this.programSetId) {
        this.fetchUnBindCopyrights()
      }
    },
    fetchUnBindCopyrights () {
      const data = {
        mediaId: this.formValue.outsideId,
        type: 0,
        drmsid: this.formValue.copyrightCode,
        createBy: ''
      }
      if (process.env.VUE_APP_NODE_ENV == 'VOD') {
        data.createBy = this.$store.state.router.createBySuffix
      } else {
        data.createBy = this.$store.state.router.createBy
      }
      fetchUnBindCopyrights(data).then((res) => {
        if (res.code == '1') {
          this.formValue.copyright = ''
          this.formValue.copyrightCode = ''
          this.formValue.crBeginDate = ''
          this.formValue.crEndDate = ''
          this.formValue.filmId = ''
          this.$message({
            message: '取消绑定成功，请进行保存操作',
            type: 'success'
          })
        }
      })
    },
    searchHandle () {
      if (this.programSetId) {
        this.fetchPutPrograms()
      } else {
        this.fetchNewPrograms()
      }
    },
    completeHandle () {
      this.$router.push({
        path: process.env.VUE_APP_NODE_ENV == 'CP' ? '/cp/programGroupManagement' : '/vod/programGroupManagement'
      })
    },
    // 新增
    fetchNewPrograms () {
      delete this.formValue.createTime
      delete this.formValue.updateTime
      delete this.formValue.updateBy
      delete this.formValue.key
      this.formValue.labels = this.formValue.keywords
      delete this.formValue.keywords
      var sndOptionsArr = this.sndOptions
      this.formValue.sndCategory = sndOptionsArr.join(' ')
      if (process.env.VUE_APP_NODE_ENV == 'VOD') {
        this.formValue.createBy = this.$store.state.router.createBySuffix
      } else {
        this.formValue.createBy = this.$store.state.router.createBy
      }
      addProgramSets(this.formValue).then((res) => {
        if (res.code == '1') {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
          this.pageInit()
        }
      })
    },
    // 编辑
    fetchPutPrograms () {
      delete this.formValue.updateTime
      delete this.formValue.key
      this.formValue.updateBy = this.$store.state.router.updateBy
      var sndOptionsArr = this.sndOptions
      this.formValue.sndCategory = sndOptionsArr.join(' ')
      this.formValue.labels = this.formValue.keywords
      delete this.formValue.keywords
      if (process.env.VUE_APP_NODE_ENV == 'CP') {
        if (this.formValue.poster.split('cp').length == 2) {
          this.formValue.poster = this.formValue.poster.split('cp')[1]
        }
        if (this.formValue.posterH.split('cp').length == 2) {
          this.formValue.posterH = this.formValue.posterH.split('cp')[1]
        }
      } else if (process.env.VUE_APP_NODE_ENV == 'VOD') {
        if (this.formValue.poster.split('vod/image').length == 2) {
          this.formValue.poster = this.formValue.poster.split('vod/image')[1]
        }
        if (this.formValue.posterH.split('vod/image').length == 2) {
          this.formValue.posterH = this.formValue.posterH.split('vod/image')[1]
        }
        this.formValue.updateBy = this.$store.state.router.updateBySuffix
      }
      editProgramSets(this.formValue).then((res) => {
        if (res.code == '1') {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    }
  },
  computed: {
    searchData () {
      const defaultData = [
        { prop: 'name', type: 'input', label: '节目集名称：', placeholder: '请输入标题', clearable: false, labelWidth: '120px' },
        {
          prop: 'nameInitials', type: 'input', label: '名称首字母：', placeholder: '请输入标题首字母', clearable: false, labelWidth: '120px'
        },
        { prop: 'category', type: 'select', label: '分类：', filterable: true, options: this.categoryList, change: this.categoryChange },
        { prop: 'sndCategory', type: 'slot', label: '二级分类：', labelWidth: '120px' },
        { prop: 'keywords', type: 'slot', label: '标签：', className: 'keywords-width', maxlength: 30 },
        { prop: 'dsc', type: 'textarea', label: '简介：', rows: '2', className: 'dsc-width' },
        { prop: 'poster', type: 'slot', label: '竖海报：', className: 'poster-width' },
        { prop: 'posterH', type: 'slot', label: '横海报：', className: 'poster-width' }
        // { prop: 'copyright', type: 'slot', label: '版权方：', className: 'copyright-width' },
        // { prop: 'copyrightCode', type: 'input', label: '版权编码：', placeholder: '请输入版权编码', disabled: true, labelWidth: '100px' },
        // {
        //   prop: 'crBeginDate',
        //   type: 'time',
        //   timeType: 'date',
        //   format: 'yyyy-MM-dd',
        //   valueFormat: 'yyyy-MM-dd',
        //   label: '版权生效时间：',
        //   placeholder: '请输入版权生效时间',
        //   disabled: true,
        //   clearable: false,
        //   labelWidth: '115px'
        // },
        // {
        //   prop: 'crEndDate',
        //   type: 'time',
        //   format: 'yyyy-MM-dd',
        //   valueFormat: 'yyyy-MM-dd',
        //   label: '版权失效时间：',
        //   placeholder: '请输入版权失效时间',
        //   disabled: true,
        //   clearable: false,
        //   labelWidth: '115px'
        // },
      ]
      const defaultAddData = []
      // if (process.env.VUE_APP_NODE_ENV == 'VOD') {
      //   defaultVODData = [{ prop: 'score', type: 'slot', label: '评分：' }, { prop: 'isCoverSonProCP', type: 'slot', label: '覆盖子节目版权：', labelWidth: '130px', className: 'isCoverSonProCP-width' }]
      // }
      return [...defaultData, ...defaultAddData, ...this.extraData]
    }
  }
}
</script>
<style lang="less">
.dsc-width{
  width: 100%;
}
.keywords-width {
  width: 100%;
}
.copyright-width,.copyrightBtn-width,.copyrightCode-width {
  width: 100%;
}
</style>
